module.exports = __webpack_public_path__ + "img/yachting.35323eda.svg";